import { isEmpty } from 'lodash';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { createSelectors } from '~frontend-common/store/create-selectors';

interface AuthStoreState {
  otp?: {
    token: string;
    generationDate: string;
    email: string;
  };

  userId: string;
  accessToken: string;
}

interface AuthStoreActions {
  setOtp: (otp: AuthStoreState['otp']) => void;
  clearOtp: () => void;

  setAuth: (userId: string, accessToken: string) => void;
  clearAuth: () => void;
  isLoggedIn: () => boolean;
}

const initialState: AuthStoreState = {
  otp: undefined,

  userId: '',
  accessToken: '',
};

export const useAuthStore = createSelectors(
  create<AuthStoreState & AuthStoreActions>()(
    // Devtool middleware for actions history and time traveling
    // See: https://github.com/pmndrs/zustand/blob/main/docs/middlewares/devtools.md
    devtools(
      // The persist middleware automatically persists the store to localStorage
      // See: https://github.com/pmndrs/zustand/blob/main/docs/middlewares/persist.md
      persist(
        (set, get) => ({
          ...initialState,

          setOtp: (otp: AuthStoreState['otp']) => set({ otp }, false, 'setOtp'),
          clearOtp: () => set({ otp: undefined }, false, 'clearOtp'),

          setAuth: (userId: string, accessToken: string) => set({ userId, accessToken }, false, 'setAuth'),

          isLoggedIn: () => {
            const { userId, accessToken } = get();

            return !isEmpty(userId) && !isEmpty(accessToken);
          },

          clearAuth: () => set(initialState, false, 'clearAuth'),
        }),
        { name: 'authStore' },
      ),
      { store: 'authStore' },
    ),
  ),
);
